export const envVars = {
  APP_NAME: 'repossession-frontend',
  PUBLIC_URL: process.env.PUBLIC_URL || '',
  REACT_APP_ENV: process.env.REACT_APP_ENV || '',
  PORT: process.env.PORT || '',
  SKIP_PREFLIGHT_CHECK: process.env.SKIP_PREFLIGHT_CHECK || '',
  CREDITAS_HOST: process.env.CREDITAS_HOST || '',
  GREENCARE_HOST: process.env.GREENCARE_HOST || '',
  REACT_APP_DATADOG_APPLICATION_ID:
    process.env.REACT_APP_DATADOG_APPLICATION_ID || '',
  REACT_APP_DATADOG_CLIENT_TOKEN:
    process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
  REACT_APP_DATADOG_VERSION: process.env.DEPLOY_ID || '',
};
